import { defineMessages, type MessageDescriptor, useIntl } from 'react-intl';

import { Link, LinkVariant } from '@jsmdg/yoshi';
import { eventTypes } from '../../types';

const messages = defineMessages({
    cartLink: {
        defaultMessage: 'Warenkorb',
    },
});

const CartLinkSnackbarContent = ({
    errorMessage,
}: {
    readonly errorMessage: { title: MessageDescriptor; body: MessageDescriptor };
}) => {
    const intl = useIntl();

    return (
        <>
            <p className="fw-semibold">{intl.formatMessage(errorMessage.title)}</p>
            <p>
                {intl.formatMessage(errorMessage.body, {
                    cartLink: (
                        <Link
                            variant={LinkVariant.BrandCancel}
                            onClick={() =>
                                document.dispatchEvent(new Event(eventTypes.NAVIGATE_CART))
                            }
                        >
                            {intl.formatMessage(messages.cartLink)}
                        </Link>
                    ),
                })}
            </p>
        </>
    );
};

export { CartLinkSnackbarContent };
